import React from 'react';
import SpriteEl from '../SpriteEl/SpriteEl';

function NotesListItem({
	noteId = "",
	title = "",
	url = "",
	text = "",
	infoName = "",
	date = "",
	time = "",
	onDelete = () => { },
	onclick = () => { },
}) {
	const handleDeleteClick = (event) => {
		event.stopPropagation();
		onDelete(noteId);
	};

	const handleNoteClick = (event) => {
		if (event.target.className !== "notes-list-item__title") {
			onclick(event);
		}
	}

	return (
		<div className="notes-list-item" onClick={handleNoteClick}>
			<a href={url} className="notes-list-item__title">
				{title}
			</a>
			<div className="notes-list-item__text">
				{text}
			</div>
			<div className="notes-list-item__info">
				<div className="notes-list-item__info-period">
					<div className="notes-list-item__info-period-item">
						<SpriteEl
							id="calendar-outline"
						/>
						<span>
							{date}
						</span>
					</div>
					<div className="notes-list-item__info-period-item">
						<SpriteEl
							id="time-outline"
						/>
						<span>
							{time}
						</span>
					</div>
				</div>
			</div>
			<button type="button" className="notes-list-item__delete" onClick={handleDeleteClick}>
				<SpriteEl
					id="trash-rounded"
				/>
			</button>
		</div>
	);
}

export default NotesListItem;
